import axios from '../../apis/approvalsApi';


export const FETCH_APPLICATION_REQUEST = 'FETCH_APPLICATION_REQUEST';
export const FETCH_APPLICATION_SUCCESS = 'FETCH_APPLICATION_SUCCESS';
export const FETCH_APPLICATION_FAILURE = 'FETCH_APPLICATION_FAILURE';
export const UPDATE_APPLICATION_REQUEST = 'UPDATE_APPLICATION_REQUEST';
export const UPDATE_APPLICATION_SUCCESS = 'UPDATE_APPLICATION_SUCCESS';
export const UPDATE_APPLICATION_FAILURE = 'UPDATE_APPLICATION_FAILURE';

export const fetchApplicationRequest = () => ({
    type: FETCH_APPLICATION_REQUEST,
});

export const fetchApplicationSuccess = (data) => ({
    type: FETCH_APPLICATION_SUCCESS, payload: data,
});

export const fetchApplicationFailure = (error) => ({
    type: FETCH_APPLICATION_FAILURE, payload: error,
});

export const updateApplicationRequest = () => ({
    type: UPDATE_APPLICATION_REQUEST,
});

export const updateApplicationSuccess = (data) => ({
    type: UPDATE_APPLICATION_SUCCESS, payload: data,
});

export const updateApplicationFailure = (error) => ({
    type: UPDATE_APPLICATION_FAILURE, payload: error,
});

/**
 * Action creator for fetching application data.
 * @param {string} jwt - JSON Web Token for authentication.
 * @returns {Function} - Async function dispatching actions based on the API response.
 */
export const fetchApplicationData = (jwt) => async (dispatch) => {
    try {
        // Dispatch the action to indicate that the request is in progress.
        dispatch(fetchApplicationRequest());

        // Set up the headers for the request, including the JWT for authentication.
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make a GET request to the API endpoint for fetching application data.
        const response = await axios.get('/application', { headers: headers });

        // Log the response data for debugging purposes.
        console.log(response?.data);

        // Dispatch an action with the data from the response to indicate success.
        dispatch(fetchApplicationSuccess(response.data));
    } catch (ex) {
        // If an exception occurs during the request, dispatch an action with the error information.
        dispatch(fetchApplicationFailure(ex.response?.data || ex.message));
    }
};

/**
 * Action creator for updating application data.
 * @param {Object} params - Parameters for the action.
 * @param {Object} params.application - The updated application data.
 * @param {string} params.jwt - JSON Web Token for authentication.
 * @returns {Function} - Async function dispatching actions based on the API response.
 */
export const updateApplicationData = ({ application, jwt }) => async (dispatch) => {
    try {
        // Dispatch the action to indicate that the request is in progress.
        dispatch(updateApplicationRequest());

        // Set up the headers for the request, including the JWT for authentication.
        const headers = {
            'Authorization': 'Bearer ' + jwt,
        };

        // Make a PUT request to the API endpoint for updating application data.
        const response = await axios.put('/application/' + application.id, application, { headers: headers });

        // Log the response data for debugging purposes.
        console.log(response?.data);

        // Dispatch an action with the data from the response to indicate success.
        dispatch(updateApplicationSuccess(response.data));
    } catch (ex) {
        // If an exception occurs during the request, dispatch an action with the error information.
        dispatch(updateApplicationFailure(ex.response?.data || ex.message));
    }
};
